import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import CustomPopupModel from '../custom-popup/Custom-Popup';

const SessionExpiredModal = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const onSignInAgain = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      try {
        history.push('/login');
      } catch (e) {
        window.location.href = '/login';
      }
    }, 50);
  }, [history]);

  const onClose = useCallback(() => {
    // no-op to keep modal open until user confirms
  }, []);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('session-expired', handler);
    return () => window.removeEventListener('session-expired', handler);
  }, []);

  const popUp = useMemo(
    () => ({
      status: open,
      title: 'Your session has expired',
      description: 'You have been signed out of the console.',
      buttonName: 'Sign in again'
    }),
    [open]
  );

  return (
    <CustomPopupModel
      popUp={popUp}
      onClick={onSignInAgain}
      onClickSwap={() => {}}
      onClickCancel={onClose}
      NoCancelButtonNeeded={true}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    />
  );
};

export default SessionExpiredModal;
